// extracted by mini-css-extract-plugin
export default {"contractCard":"styles_contractCard__1SkDg"};